<header class="toolbar">
  <div class="toolbar-content">
    <ng-content></ng-content>
  </div>
</header>